import type { ICampaignService } from "./ICampaignService";
import type { ApiCampaign, ApiReturnCampaign } from "@highimpact-frontend/api-types";
import { api_config } from "../../../api-commons";

type SiteParam = {context : "site", id: number}
type ProjectParam = {context: "project", id: number}

export type Param = ProjectParam | SiteParam


class CampaignService implements ICampaignService {
    
    async getByEntity(params : Param) {
        const context = params.context;
        const query   = `${context}s/${params.id}/campaigns` 
        const response = await api_config.get(query);
        return response.data;
     }

    async add(params: ApiCampaign): Promise<ApiReturnCampaign> {
        const response = await api_config.post('/campaigns', params);
        return response.data;
    }

    async update(id: number, params: ApiCampaign): Promise<ApiReturnCampaign> {
        const response = await api_config.put(`/campaigns/ ${id}`, params);
        return response.data;
    }

    async delete(id: number): Promise<ApiReturnCampaign> {
        const response = await api_config.delete(`/campaigns/${id}`);
        return response.data;
    }

}

const instance = new CampaignService();
export default instance;